import React from 'react'
import { Spin } from 'antd'

const PageLoading: React.FC<{}> = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#000000',
      opacity: 0.6
    }}>
      <Spin style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }} 
        size='large'
      />
    </div>
  )
}

export default PageLoading;